import {AggregateFunctionTypeEnum, BucketUnitEnum} from "../../enums/dashboard/ChartsEnum";

export class UserReport {
  id?: number;
  name!: string;
  unixCronExpression!: string;
  enabled: boolean = true;
  email!: string;
  bucketUnits?: BucketUnitEnum = BucketUnitEnum.HOURS;
  bucketValue?: number = 1;
  metrics?: UserReportMetric[] = [];
}

export class UserReportListItem {
  id!: number;
  name!: string;
  unixCronExpression!: string;
  enabled!: boolean;
  email!: string;
  bucketUnits!: BucketUnitEnum;
  bucketValue!: number;
  metrics!: UserReportMetric[];
}

export class UserReportMetric {
  uniqueCode?: string;
  metricInstance!: ReportMetricInstance;
  functionType!: AggregateFunctionTypeEnum;
}

export class ReportMetricInstance {
  id!: number;
  name!: string;
  type!: string;
  partitionId!: number;
  partitionName!: string;
  deviceId?: number;
  deviceName?: string;
}
